import axios from "axios";

import router from '../router'

const contentType = {
  json: 'application/json; charset=utf-8',
  urlencoded: 'application/x-www-form-urlencoded; charset=utf-8',
  multipart: 'multipart/form-data',
}

// baseUrl，如：http://localhost:8080/api/
// const baseURL = process.env.NODE_ENV === 'development' ? 'http://172.16.203.22:8081' : 'http://business-board.gcszh.com.cn';
const baseURL = process.env.NODE_ENV === 'development' ? 'https://business-board.gcszh.com.cn/busAuthApi/' : 'https://business-board.gcszh.com.cn/busAuthApi/';
const timeout = 60000; // 毫秒

// 不加baseUrl
const serviceOrigin = axios.create({
  timeout: timeout // 请求超时时间
})

const service = axios.create({
  baseURL: baseURL,
  timeout: timeout // 请求超时时间
})

// http request 请求拦截器，示例代码：有token值则配置上token值，根据实际需求进行拦截调整
service.interceptors.request.use(
  config => {
    if (localStorage.getItem('token')) {  // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
      config.headers['Accesstoken'] = localStorage.getItem('token');
    }
    else{
      router.push({
        name: 'unAuth'
      })
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

// http response 响应拦截器，示例代码框架：根据不通的状态码，以及后端响应码，做出相应的逻辑处理
service.interceptors.response.use(
  function (response) {
    //console.log(response)
    // 请求成功
    if(response.status == 200){
      return Promise.resolve(response)
    }
    // 请求失败
    else{
      return Promise.reject(response);
    }
  },
  function (error) {
    // 请求失败处理代码
    return Promise.reject(error)
  }
)

// 封装常用的get、post、put、upload、download方法
const authRequestUtils = {
  postExport(url, params) {
    return service.post(url, params, {
      transformRequest: [(params) => {
        return JSON.stringify(params)
      }],
      headers: {
        'Content-Type': contentType.json
      },
      responseType: 'blob'
    })
  },
  post(url, params) {
    return service.post(url, params, {
      transformRequest: [(params) => {
        return JSON.stringify(params)
      }],
      headers: {
        'Content-Type': contentType.json
      }
    })
  },
  put(url, params) {
    return service.put(url, params, {
      transformRequest: [(params) => {
        return JSON.stringify(params)
      }],
      headers: {
        'Content-Type': contentType.urlencoded
      }
    })
  },
  get(url) {
    return service.get(url)
  },
  upload(url, params) {
    return service.post(url, params, {
      headers: {
        'Content-Type': contentType.urlencoded
      }
    })
  },
  download(url, params) {
    return service.get(url, {
      params: params,
      responseType: 'blob'
    })
  },
  postOrigin(url, params) {
    return serviceOrigin.post(url, params, {
      transformRequest: [(params) => {
        return JSON.stringify(params)
      }],
      headers: {
        'Content-Type': contentType.json
      }
    })
  },
}



export  default authRequestUtils;



// WEBPACK FOOTER //
// ./src/utils/authRequestUtils.js